import type { TechnicalInformationFormData } from "../schemas/TechnicalInformationSchema"

import type { ProductUpdateInput } from "@/graphql/codegen/graphql"

interface ToTechnicalInformationUpdateInputParams {
  productId: number
  versionNumber?: number
}

export const toTechnicalInformationUpdateInput = (
  formValues: TechnicalInformationFormData,
  { productId, versionNumber }: ToTechnicalInformationUpdateInputParams
): ProductUpdateInput => ({
  ...formValues,
  productId,
  versionNumber,
  chemicalName: formValues.chemicalName || null,
  harmonizedTariffSchedule: formValues.harmonizedTariffSchedule || null,
  unNumber: formValues.unNumber || null,
  specificGravity: Number(formValues.specificGravity) || null,
})
